

 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

export  const    playerCard1Object = { no:1, 
    id: generateTimestamp()+3,
    cardName:"PlayerCard1",
    cardType:"editable",
    myKey:`id-PlayerCard1-layout`,
   
        

         sidebarCard:{ 
         position:{title:"Sidebar Position.",position:"left"},

         layoutBG:{title:"Sidebar Background Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"double",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(85, 238, 210, 1)",colors:{},alpha:1}},
         borderRadius:{title:"Sidebar Layout Radius",
         topLeft:{title:"Top Left Radius",value:0,resolution:"px"},
         topRight:{title:"Top Right Radius",value:0,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:0,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:0,resolution:"px"}}},
        
 

          titleFonts:{ 
                headerFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } }, 
               titleFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               subtitleFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               tagsFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } },
               buttonFont:{  family:{name:"Nunito-Light",
             fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
              } }
               },
           

          milestone:{  title:"Milestone",
            
          textColor:{title:"Milestone Title Color",color:"rgba(18, 18, 18, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Milestone BG Color",color:"rgba(144, 202, 249,0.51)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Milestone icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Milestone Icon BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:" Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Milestone Card Radius",
           topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
          section:{  title:"Section",
            
          textColor:{title:" Section Title Color",color:"rgba(39, 39, 39, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Section BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Section Icon Color",color:"rgba(43, 43, 43, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Section Icon BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Section  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Section Card Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
                
          chapter:{  title:"Chapter",
            
          textColor:{title:" Chapter Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Chapter BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Chapter Icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Chapter Icon BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Chapter  Border",borderType:"solid",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Chapter Card Radius",
         topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
          
                },
          folder:{  title:"Folder",
            
          textColor:{title:" Folder Title Color",color:"rgba(32, 32, 32, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Folder BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Folder Icon Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Folder Icon BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Folder  Border",borderType:"solid",borderWidth:{title:"Border Width",value:4,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,0.11)",colors:{},alpha:1}},
          borderRadius:{title:"Folder Card Radius",
         topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
          
                }, lessonCard:{ 
                lessonCardTheme:"T2",
                 title1:"Lesson",
                 title2:"I have completed this lesson.",
                 titleQuiz:"I have completed this Quiz.",
            
          textColor:{title:" Show More Button BG Color",color:"rgba(27, 26, 26, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Show More Button BG Color",color:"rgba(237, 247, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Show More Icon & Text Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Show More Icon & Text Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          progressBarColor:{title:"Show More Icon & Text Color",color:"rgba(144, 202, 249,0.21)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          progressBarInnerColor:{title:"Show More Icon & Text Color",color:"rgba(163, 240, 227, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          toggleColor:{title:"Show More Icon & Text Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          toggleThumbColor:{title:"Show More Icon & Text Color",color:"rgba(163, 240, 227, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          toggeleCardBgColor:{title:"Show More Icon & Text Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Tag  Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Lead Card Button Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},

         imageThumbnail: {   
         status: true,
                  type:"s3Key", //link , s3Key
                  src:"https://i.postimg.cc/G24xxVq7/smiling-pensive-brunette-schoolgirl-with-long-hair-hugging-book.jpg",
                  s3Key:"",
         aspectRatio:{title:"Image Crop Ratio",value:"2/1"},
          
         borderRadius:{title:"Lead Card Image Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
         border:{title:"Image  Border",borderType:"double",
         borderWidth:{title:"Border Width",value:2,resolution:"px"}
        ,borderColor:{title:"Layout Border Color",color:"rgba(255, 255, 255, 1)",colors:{},alpha:1}},
         },
                },  
                
        
                
          topBar:{  title1:"Curriculum",title2:"Sub-courses",
            
          textColor:{title:" Show More Button BG Color",color:"rgba(1, 1, 1, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Show More Button BG Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Show More Icon & Text Color",color:"rgba(144, 202, 249,0.81)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Tag  Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,0.81)",colors:{},alpha:1}},
          borderRadius:{title:"Lead Card Button Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
        
         
          lessonCardButtons:{  title1:"comments",title2:"report", title3:"notes",title4:"pdf",
            
          textColor:{title:" Show More Button BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          btnColor:{title:" Show More Button BG Color",color:"rgba(144, 202, 249,0.21)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Show More Button BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Show More Icon & Text Color",color:"rgba(144, 202, 249,0.81)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconBgColor:{title:"Show More Icon & Text Color",color:"rgba(253, 249, 249, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Tag  Border",borderType:"solid",borderWidth:{title:"Border Width",value:2,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(144, 202, 249,1)",colors:{},alpha:1}},
          borderRadius:{title:"Lead Card Button Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
                
         
         
                video:{
                           playerTheme:"Classic",// Classic, Modern 
                           sourceType:"youtube",// 1youtube , 2vimeo , 3mp4URL , 4(uploadVideo) 
                           youtube:{src:"https://www.youtube.com/watch?v=qFLhGq0060w",
                           showDefaultThumbnail:true
                           ,useDefaultPlayer:false },
                            vimeo:{src:"https://vimeo.com/837164312"
                           ,useDefaultPlayer:false},
                            mp4URL:{src:"http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" },
                            uploadedVideoURL:{src:"" },
                            videoThumbnail:{
                                src:"https://i.postimg.cc/t4YRDRbd/6390.jpg",hideThumbnail:false,
                                            },
                           
                                  videoPlayButton:{
                                     playButtonBorderRadius:{value:50,resolution:"px"} ,
                                     playButtonColor:{normal:{title:"Slide & Title Background Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(144, 202, 249,1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{title:"Slide & Title Background Color",color:"rgba(144, 249, 160, 1)",colors:{color10:"rgba(144, 202, 249,1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1}} ,
                                     playIconColor:{normal:{title:"Slide & Title Background Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(144, 202, 249,1)",color5:"rgba(187, 247, 247, 0.93)"},alpha:1},hover:{}}  ,
                                    
                                   
                                          }
                    },

         playerCard:{
         layoutBG:{title:"Player Card Background Color",color:"rgba(144, 202, 249,0.11)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
         border:{title:"Card  Border",borderType:"dotted",borderWidth:{title:"Border Width",value:0,resolution:"px"},borderColor:{title:"Layout Border Color",color:"rgba(106, 249, 222, 0.31)",colors:{},alpha:1}},
         borderRadius:{title:"Player Card Layout Radius",
         topLeft:{title:"Top Left Radius",value:150,resolution:"px"},
         topRight:{title:"Top Right Radius",value:10,resolution:"px"},
         bottomLeft:{title:"Bottom Left Radius",value:30,resolution:"px"},
         bottomRight:{title:"Bottom Right Radius",value:50,resolution:"px"}}
         
                     },
     
         progressBar:{ hideProgressbar:false,
             title:"Course Progress",
           
             textColor:{title:" Show More Button BG Color",color:"rgba(20, 20, 20, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
       
                },

                 

           playerButtons:{  title1:"Ask AI"
           ,title2:"Bookmark",title3:"Summary",title4:"AI Quizzes",
            
          textColor:{title:" Show More Button BG Color",color:"rgba(5, 5, 5, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          bgColor:{title:" Show More Button BG Color",color:"rgba(255, 255, 255, 1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          iconColor:{title:"Show More Icon & Text Color",color:"rgba(144, 202, 249,1)",colors:{color10:"rgba(255, 255, 255, 1)"},alpha:1},
          border:{title:"Tag  Border",borderType:"solid",borderWidth:{title:"Border Width",value:4,resolution:"px"},borderColor:{title:"Button Border Color",color:"rgba(219, 251, 255, 1)",colors:{},alpha:1}},
          borderRadius:{title:"Lead Card Button Radius",
          topLeft:{title:"Top Left Radius",value:10,resolution:"px"},
          topRight:{title:"Top Right Radius",value:10,resolution:"px"},
          bottomLeft:{title:"Bottom Left Radius",value:10,resolution:"px"},
          bottomRight:{title:"Bottom Right Radius",value:10,resolution:"px"}},
       
                },
          
       
          
          
       
          
          
      
          
        
    
        


            
     
                       
         
        }